import React from 'react';
import { useTranslation } from 'react-i18next';
import './index.css';

const Contact: React.FC = () => {
  const { t } = useTranslation();
  const bannerImagePath = '/images/contact/banner.webp';
  
  return (
    <main className="contact-container">
      {/* 页面标题区域 */}
      <section className="contact-hero-section">
        <div 
          className="contact-hero-background"
          style={{
            backgroundImage: `url('${bannerImagePath}')`
          }}
        >
          <div className="contact-hero-overlay">
            <div className="contact-hero-container">
              <h1 className="contact-hero-title">{t('contact.title')}</h1>
              <p className="contact-hero-subtitle">
                {t('contact.subtitle')}
              </p>
              <p className="contact-hero-description">
                {t('contact.description')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 联系信息展示区域 */}
      <section className="contact-info-section">
        <div className="contact-info-container">
          <div className="contact-text-content">
            <div className="company-info-item">
              <span className="info-label">{t('contact.companyName')}</span>
              <span className="info-value">{t('contact.companyNameValue')}</span>
            </div>

            <div className="company-info-item">
              <span className="info-label">{t('contact.address')}</span>
              <span className="info-value">{t('contact.addressValue')}</span>
            </div>

            <div className="company-info-item">
              <span className="info-label">{t('contact.domesticBusiness')}</span>
              <span className="info-value">+86-13679743743</span>
            </div>

            <div className="company-info-item">
              <span className="info-label">{t('contact.foreignBusiness')}</span>
              <span className="info-value">+86-13642736731</span>
            </div>

          </div>

          {/* 公司位置地图 */}
          <div className="map-section">
            <div className="map-wrapper">
              <div className="map-container">
                <iframe
                  src="https://map.baidu.com/search/%E5%BE%B7%E8%AF%9A%E7%A7%91%E6%8A%80%E5%9B%AD/@12579046.435,2680514.6,19z?querytype=s&da_src=shareurl&wd=%E5%BE%B7%E8%AF%9A%E7%A7%91%E6%8A%80%E5%9B%AD&c=257&src=0&wd2=%E6%B8%85%E8%BF%9C%E5%B8%82%E6%B8%85%E5%9F%8E%E5%8C%BA&pn=0&sug=1&l=13&b=(12595019,2607154;12640299,2636178)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&sug_forward=56257dceb24a2254ad31e52e&device_ratio=2"
                  width="100%"
                  height="350"
                  frameBorder="0"
                  scrolling="no"
                  title={t('contact.title')}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
